// @flow
import styled, { css } from "styled-components"

export const InputWrapWrap = styled.label`
  display: block;
  width: 100%;
  ${p => !p.noMargin &&
    css`
      margin-bottom: 2.4rem;
    `}
`

export const MultiInputWrapWrap = styled.fieldset`
  display: block;
  width: 100%;
  margin-bottom: 2.4rem;
  border: none;
  padding: 0;
`

export const Error = styled.div`
  color: ${(props) => props.theme.color.red};
  font-size: 1.2rem;
  position: ${props => props.errorPosition || "relative"};
`



// WEBPACK FOOTER //
// ./src/forms/withFormField/InputWrap/styled.js